import { fileUploadSizeLabel } from 'common/constants';

const documentCategory = {
  title: 'Select a category',
  categoryFieldLabel: 'Let’s start by selecting a category',
  categoryEditLabel: 'Select categories',
  buttonText: 'CONTINUE',
  updateButtonText: 'SAVE',
};
const documentGiveItName = {
  title: 'Give it a name',
  nameFieldLabel: 'Name of the document',
  namePlaceHolder: 'Max 60 characters',
  categoryFieldLabel: 'Select a categories',
  categoryEditLabel: 'Select categories',
  buttonText: 'CONTINUE',
  nameRequired: 'Please add a name',
  nameMaxLimit: 'The maximum character limit is 60',
  updateButtonText: 'SAVE',
};

const documentDVLA = {
  title: 'Add a vehicle',
  chooseVehicleTitle: 'Choose a vehicle',
  dvlaHelpText: 'You can pull out all the important information about your vehicle from ',
  dvla: 'DVLA. ',
  dvlaHelpTextPart: 'Find your vehicle  by entering your vehicle’s registration number.',
  nameFieldLabel: 'Registration number',
  namePlaceHolder: 'example: BD51 SMR',
  vehicleNameField: 'Name your vehicle (optional)',
  vehicleNamePlaceholder: 'Enter a name',
  buttonText: 'CONTINUE',
  nameRequired: 'Please enter your vehicle\'s registration number',
  nameMaxLimit: 'The maximum character limit is 60',
  updateButtonText: 'SAVE',
};

const documentVehicle = {
  title: 'Vehicle information',
  dvlaHelpText: 'You can pull out all the important information about your vehicle from DVLA. Find your vehicle  by entering your vehicle’s registration number.',
  nameFieldLabel: 'Registration number',
  namePlaceHolder: 'example: BD51 SMR',
  vehicleNameField: 'Name your vehicle (optional)',
  vehicleNamePlaceholder: 'Enter a name',
  buttonText: 'Continue',
  nameRequired: 'Please enter your vehicle\'s registration number',
  updateButtonText: 'SAVE',
  motDataMissing: 'No details held by DVLA',
};

const documentRenewal = {
  title: 'Set renewal date',
  dateFieldLabel: 'Set the renewal/expiry date',
  datePlaceHolder: 'DD/MM/YYYY',
  dateFormat: 'dd/MM/yyyy',
  previewDateFormat: 'DD/MM/YYYY',
  toggleReminderLable: 'Remind me in advance',
  toggleRepeatLable: 'Repeat',
  buttonText: 'CONTINUE',
  dateFileName: 'renewal_date',
  renewalDateRequired: 'Please set a renewal date',
  beforeFieldSelector: 'text-before',
  repeatFieldSelector: 'text-repeat',
  dayNumberError: 'Please enter a number',
  dayMustBePositiveError: 'Please set a value greater than zero',
  reminderSetFormat: 'YYYY-MM-DD',
};

const dashboardText = {
  reminderSubHeading: 'Due date in %expirationDays% days',
  reminderSubHeadingExpiresTommorow: 'Due date tomorrow',
  reminderSubHeadingExpired: 'Due date %expirationDays% days ago',
  reminderSubHeadingExpiredToday: 'Due date today',
  reminderHeading: 'Car Insurance',
  documentsHeading: 'What are you looking for?',
  categories: 'Categories',
  reminderHint: 'Your new reminders will appear here',
  documentName: 'Docs',
  dummyText: '10/06/2022',
  deletBtnText: 'Delete',
  laterBtnText: 'Later',
  doneBtnText: 'Done',
  multiReminderText: 'more reminders',
  deleteSecondaryButtonText: 'Cancel',
  deleteSubHeading: 'Are you sure you want to delete this reminder?',
  deleteInfoText: 'This will not delete your document',
  donePrimaryButtonText: 'Yes, Done',
  doneHeading: 'Done',
  doneSubHeading: 'Are you sure you want to mark this reminder as done?',
  laterHeading: 'Remind Me Later',
  laterSubHeading: 'Renewel Date',
  laterPara: 'Set new reminder',
  laterPrimaryBtnText: 'Save',
  gridLoadError: "Couldn't load your Doqs. Tap to retry.",
};

const documentUpload = {
  title: 'Attach a file',
  buttonText: 'CONTINUE',
  fileError: 'Please attach a file',
  fileSizeError: `File size can not be more than ${fileUploadSizeLabel}`,
  unsupportedFileFormat: 'File format not supported',
  scanAssemblyError: "We couldn't prepare that scan. Please try scanning it again, or scan fewer pages at a time.",
};

const lockedFiles = {
  heading: 'This file has a password',
  headingPlural: 'These files have passwords',
  subHeading: 'Enter the password so Doqit can read it and fill in the details for you.',
  subHeadingPlural: 'Enter the passwords so Doqit can read them and fill in the details for you.',
  privacyNote: 'The password stays on your device. The file is saved exactly as it is, still locked.',
  passwordPlaceholder: 'Password',
  sameForAll: 'Use this password for all of them',
  unlockButton: 'Unlock and continue',
  unlockingButton: 'Unlocking...',
  skipButton: 'Save without reading',
  wrongPassword: "That password didn't work",
  unlockFailed: "We couldn't open this file. It will be saved as it is.",
  unlocked: 'Unlocked',
  bannerTitle: 'This file has a password',
  bannerBody: "Doqit couldn't read it, so nothing was filled in. Unlock it and the details will be added for you.",
  bannerButton: 'Unlock and read',
  readSuccess: 'Read it. Details have been filled in.',
  readNothing: 'Read it, but there was nothing new to add.',
  readFailed: "We couldn't read that file. Please try again.",
};

const documentUploadDone = {
  helpText: 'Now you’ll always have access to your information and will get notifications before it expires or renews.',
  subTitle: 'Done!',
  addNewDocument: 'ADD ANOTHER DOCUMENT',
};

const documentReview = {
  title: 'Review',
  buttonText: 'SAVE DOCUMENT',
  documentNameTitle: 'Name:',
  documentCategoryTitle: 'Category:',
  documentRenewalTitle: 'Renewal/expiry date:',
  remindeTitle: 'Reminders:',
  attachedFiles: 'Attached files:',
  vehicleTitle: 'Vehicle:',
};
const searchDocumentText = {
  searhInputPlaceHolder: 'Search your documents',
  renewalDate: 'Renewal Date',
  pin: 'Pin to top',
  editDocument: 'Edit Document',
  share: 'Share with Others',
  delete: 'Delete',
  noResult: 'No result found',
  unPin: 'Unpin',
  editDocumentText: 'Edit documents is part of upcoming sprint',
  sortLabelBest: 'Best match',
  sortLabelRenewal: 'Renewal date',
  sortLabelAdded: 'Recently added',
  sortLabelName: 'Name A-Z',
  filterHasRenewal: 'Has renewal',
  filterRenews30: 'Renews in 30 days',
  filterRenews90: 'Renews in 90 days',
  filterClear: 'Clear filters',
  filterButton: 'Filter',
  filterCategoriesLabel: 'Categories',
  filterRenewalLabel: 'Renewals',
  noFilterResult: 'No documents match these filters',
  quickAccessPinned: 'Pinned',
  quickAccessRecent: 'Recent',
  searchLoadError: "Couldn't load your search results. Tap to retry.",
};

const loading = {
  text: 'Loading...',
};

const documentsPage = {
  documentsPageHeading: 'Docs',
  renewalDate: 'Renewal Date',
  pin: 'Pin to top',
  editDocument: 'Edit Document',
  share: 'Share with Others',
  delete: 'Delete',
  deleteHeading: 'Delete?',
  deleteSubHeading: 'Are you sure you want to delete this document? This action cannot be undone.',
  deletePrimaryButtonText: 'Yes, Delete',
  deleteSecondaryButtonText: 'No, Thanks',
  noDocument: 'You have not added any documents yet. You can add a document by clicking the + button from navigation bar.',
  docsLoadError: "Couldn't load your documents. Tap to retry.",
};

const editDocumentText = {
  categoryLabel: 'Category',
  documentName: 'Name',
  renewelDate: 'Renewal date',
  reminder: 'Reminders',
  attachedFiles: 'Attached files',
  months: 'months',
  days: 'days',
  before: 'before',
  annually: 'annually',
  monthly: 'monthly',
  repeat: 'Repeat',
  vehicleLabel: 'Vehicle:',
  noReminder: 'No Reminder',
};

const reminderText = {
  reminderLabel: 'Reminders',
  reminderNotFound: "You're up to date on your reminders!",
  upcomingTabName: 'Upcoming',
  doneTabName: 'Done',
  timelineTabName: 'Timeline',
  timelineError: "Couldn't load your timeline. Tap to retry.",
  upcomingLoadError: "Couldn't load your upcoming reminders. Tap to retry.",
  doneLoadError: "Couldn't load your done reminders. Tap to retry.",
  upcomingTabContent: 'Upcoming Text Content',
  doneTabContent: 'Done Text Content',
  expire: 'Expire: ',
  markedDone: 'Marked as done: ',
  overdue: 'Overdue',
  thisWeek: ' Next 7 days',
  nextMonth: 'Next 60 days',
  thisMonth: 'Next 30 days',
  next3Month: 'Next 90 days',
  thisYear: 'Later this year',
  moreThanOneYear: 'Next year',
  getExpiryDateFormat: 'YYYY-MM-DD',
  days: 'days',
};

const menuBarPage = {
  content: 'This is part of upcoming sprint',
};

const successPageText = {
  content: 'Thank you for choosing doqit. Now let’s have it working for you straight away!',
};

const menuBarPageText = {
  myProfile: 'My profile',
  privacyPolicy: 'Personal data processing',
  aboutDoqit: 'About Doqit',
  pricing: 'Pricing',
  cancelPlan: 'Cancel subscription',
  faq: 'FAQ',
  feedback: 'Feedback',
  deleteAccount: 'Delete account',
  logout: 'Log out',
  myProfileText: 'This page would develop in upcoming stories',
  supportMail: 'support@doqit.io',
  deletePopupSubHeading: 'Are you sure you want to delete your account?',
  cancelPlanPopupSubHeading: 'Are you sure you want to cancel your subscription?',
  changePassword: 'Change Password',
  deletePrimaryButtonText: 'Cancel',
  cancelPlanPrimaryButtonText: 'Cancel',
  deleteSecondaryButtonText: 'Yes, Delete',
  cancelPlanSecondaryButtonText: 'Yes, Cancel',
  myProfileTns: 'doqit does not store any of your information once deleted. Deleted information cannot be recovered',
  logoutPopupSubHeading: 'Are you sure you want to log out?',
  logoutSecondaryButtonText: 'Yes, Log out',
  privacyPolicyMenu: 'Privacy policy',
  resetPassword: 'Reset password',
  deleteConfirmation: 'Type DELETE and click YES, DELETE to continue with delete account',
  infoText: 'This action cannot be undone.',
  cancelPlanInfoText: 'doqit will continue to store your information until you delete your account.',
  changeEmail: 'Change',
  changeEmailTitle: 'Change your email',
  changeEmailIntro: "We'll send a code to your new address to make sure it's yours.",
  changeEmailNewLabel: 'New email address',
  changeEmailPasswordLabel: 'Current password',
  changeEmailSendCode: 'Send code',
  changeEmailCodeTitle: 'Check your inbox',
  changeEmailCodeIntro: 'Enter the 6-digit code we sent to',
  changeEmailCodeLabel: 'Code',
  changeEmailConfirm: 'Confirm',
  changeEmailCancel: 'Cancel',
  changeEmailBack: 'Use a different address',
  changeEmailDone: 'Your email address has been updated.',
  changeEmailGenericError: 'Something went wrong. Please try again.',
};

const vehiclePageText = {
  yourvehicles: 'Your vehicles:',
  vehicleDocs: 'Vehicle documents:',
  sharedVehicles: 'Shared vehicles:',
  sharedWithMe: 'SHARED WITH ME',
  docs: 'Docs: ',
  vehicle: 'Vehicle: ',
  delete: 'Delete',
  deleteSubHeading: 'Are you sure you want to delete this vehicle?',
  deleteInfoText: 'This action cannot be undone',
  colour: 'Colour',
  fuelType: 'Fuel Type',
  dateRegistered: 'Date registered',
  addVehicle: 'Add a vehicle',
  editVehicle: 'Edit Vehicle',
};

const propertyPageText = {
  title: 'Properties',
  myProperties: 'My Properties',
  sharedProperties: 'Shared properties:',
  sharedWithMe: 'SHARED WITH ME',
  addProperty: 'Add a property',
  editProperty: 'Edit property',
  selectProperty: 'Select a property',
  propertyName: 'Property name',
  propertyNamePlaceholder: 'e.g. Home, Office, Investment Property',
  addressSearch: 'Search for address',
  addressSearchPlaceholder: 'Start typing an address...',
  addressLine1: 'Address line 1',
  addressLine2: 'Address line 2 (optional)',
  city: 'City',
  stateProvince: 'County/Region',
  postcode: 'Postcode',
  country: 'Country',
  customFields: 'Additional details',
  customFieldsHint: 'Add details like Property Type, Bedrooms, Year Built, Square Footage, etc.',
  addField: 'Add field',
  fieldName: 'Field name',
  fieldValue: 'Value',
  noProperties: 'No properties added yet',
  propertyDocuments: 'Property Documents',
  delete: 'Delete',
  deleteConfirm: 'Delete this property?',
  deleteSubHeading: 'Are you sure you want to delete this property?',
  deleteInfo: 'Documents will remain in the Property category.',
  skipForNow: 'Skip for now',
  continue: 'Continue',
  save: 'Save property',
  docs: 'Docs: ',
  documentsCount: '%count% documents',
  linkDocumentInfo: 'Link this document to a property to keep all related documents together',
  orEnterManually: 'Or enter address manually',
  useAddressSearch: 'Use address search',
};

const welcomePageText = {
  welcomeHeadlineLead: 'Every important document,',
  welcomeHeadlineEmphasis: 'out of your head',
  welcomeHeadlineEnd: '.',
  welcomeSubheadline: 'Doqit names it, files it and reminds you before it matters.',
  createAccount: 'Get Started',
  alreadyHaveAccount: 'Have an account?',
  login: 'Login',
};

const mfaPage = {
  title: 'Verification',
  enterCode: 'Please enter the verification code below',
  sentTo: 'We\'ve sent a code to ',
  noCode: 'Didn\'t get a code?',
  resend: 'CLICK TO RESEND',
  verify: 'Verify',
  errorMessage: 'Please enter a valid code',
};

const sharingText = {
  // My Sharing page
  mySharing: 'My sharing',
  mySharedLinks: 'My shared links',
  mySharedLinksSubtitle: 'View and manage all your public shareable links in one place.',
  mySharingSubtitle: 'Share your Doqit items with family members or trusted friends.',
  sharingWith: 'Sharing with:',
  sharesAll: 'Shares all',
  sharesSelectedItems: 'Shares selected items',
  youShareAllDocs: 'You: All docs',
  youShareSelectedDocs: 'You: Selected docs',
  theyShareAllDocs: 'Them: All docs',
  theyShareSelectedDocs: 'Them: Selected docs',
  canEditLabel: 'can edit',
  viewOnlyLabel: 'view only',
  addSharingAccount: 'Add A Sharing Account',
  noConnections: 'You haven\'t connected with anyone yet.',
  // Add Sharing Account page
  addSharingAccountTitle: 'Add a sharing account',
  addSharingAccountSubtitle: 'Enter an email address to connect and share your Doqit items.',
  emailLabel: 'Enter their email address',
  emailPlaceholder: 'email@example.com',
  shareAll: 'SHARE ALL',
  shareOnlySelected: 'SHARE ONLY WHAT I SELECT',
  requestInfo: 'Once the account holder has accepted your request you will be notified here and via email... and let the sharing begin!',
  requestDisclaimer: 'Any data shared with this account is done so at your discretion, and Doqit Technologies Ltd cannot be held accountable for any issues this may cause.',
  requestSharing: 'Request Sharing',
  requestSent: 'Connection request sent!',
  // Pending requests
  pendingRequests: 'Pending Requests',
  pendingRequestsSubtitle: 'Review and respond to sharing requests.',
  noPendingRequests: 'No pending requests.',
  accept: 'Accept',
  reject: 'Reject',
  // Sent requests
  sentRequests: 'Requests Sent',
  awaitingResponse: 'Awaiting response',
  cancel: 'Cancel',
  // Connection actions
  editSharing: 'Edit sharing',
  disconnect: 'Disconnect',
  disconnectConfirm: 'Are you sure you want to disconnect? This will revoke all shared documents.',
  disconnectSuccess: 'Disconnected successfully.',
  // Shared with me
  sharedWithMe: 'Shared with me',
  sharedWithMeSubtitle: 'Documents others have shared with you.',
  noSharedDocuments: 'No documents have been shared with you yet.',
  sharedBy: 'Shared by',
  viewOnly: 'View only',
  canEdit: 'Can edit',
  // Share document modal
  shareDocument: 'Share Document',
  selectConnection: 'Select who to share with',
  permission: 'Permission',
  expiryDate: 'Expiry date (optional)',
  share: 'Share',
  shareSuccess: 'Document shared successfully!',
  // Document shares list
  sharedWith: 'Shared with',
  revokeAccess: 'Revoke Access',
  revoke: 'Revoke',
  revokeConfirm: 'Are you sure you want to revoke access?',
  revokeConfirmMessage: "Are you sure you want to revoke {name}'s access to this document?",
  revokeSuccess: 'Access revoked.',
  editPermissions: 'Edit Permissions',
  editPermissionsFor: 'Update sharing permissions for',
  viewOnlyOption: 'View only',
  viewOnlyDescription: 'Can view but not edit the document',
  canEditOption: 'Can edit',
  canEditDescription: 'Can view and make changes to the document',
  save: 'Save',
  updatePermissions: 'Update Permissions',
  updateSuccess: 'Permissions updated.',
  sharedViaShareAll: 'Shared via "Share All"',
  shareAllExplanation: 'This document is automatically shared because you have enabled "Share All" with this connection. To change this, manage your sharing settings.',
  // Invitation flow (non-Doqit users)
  inviteToDoqit: 'Invite to Doqit',
  userNotOnDoqit: "This person isn't on Doqit yet. Would you like to invite them?",
  invitationSent: 'Invitation sent!',
  invitationSentMessage: "We've sent an invitation to join Doqit. Once they sign up, your connection request will be waiting for them.",
  invitedToDoqit: 'Invited to Doqit',
  resendInvite: 'Resend',
  resendCooldown: 'You can resend in 1 hour',
  alreadyInvited: "You've already invited this person",
  invitationCancelled: 'Invitation cancelled',
  cancelInvitation: 'Cancel Invitation',
  // Errors
  userNotFound: 'No premium user found with that email.',
  alreadyConnected: 'You are already connected with this user.',
  requestAlreadySent: 'A connection request has already been sent.',
  premiumRequired: 'Premium subscription required for sharing.',
  // Vehicle/Property sharing warning
  vehicleShareWarningTitle: 'Heads up!',
  vehicleShareWarning: 'This document is linked to your vehicle. When you share it, '
    + 'the recipient will also be able to see your vehicle details (registration, make, model, etc.) '
    + 'in their Vehicles section.',
  propertyShareWarning: 'This document is linked to your property. When you share it, '
    + 'the recipient will also be able to see your property details (address, name, etc.) '
    + 'in their Properties section.',
  vehiclePropertyShareWarning: 'This document is linked to both your vehicle and property. '
    + 'When you share it, the recipient will be able to see details about both in their respective sections.',
  continueSharing: 'Continue',
  cancelSharing: 'Cancel',
};

export const lang = {
  documentCategory,
  documentGiveItName,
  documentDVLA,
  documentVehicle,
  documentRenewal,
  dashboardText,
  documentUpload,
  lockedFiles,
  documentUploadDone,
  searchDocumentText,
  documentReview,
  loading,
  documentsPage,
  editDocumentText,
  reminderText,
  successPageText,
  menuBarPage,
  menuBarPageText,
  vehiclePageText,
  propertyPageText,
  welcomePageText,
  mfaPage,
  sharingText,
};

export default lang;
